import { Subscription } from 'rxjs';
import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ViewWorkDataQuestion, ViewWorkRTIType, ViewWorkTemplateType, QuestionTypeEnum } from 'src/app/Elearning-Models';

@Component({
  selector: 'app-question-grading',
  templateUrl: './question-grading.component.html',
  styleUrls: ['./question-grading.component.scss']
})
export class QuestionGradingComponent implements OnInit {
  @Input() pointsEarned: number;
  @Input() pointsAvailable: number;
  @Input() questionType: number;
  @Input() question: ViewWorkDataQuestion;
  @Input() correct: boolean;
  @Input() isConsumerCurriculum: boolean;
  @Output() gradeStatusChanges: EventEmitter<string> = new EventEmitter<string>();
  @Output() partialCreditChanges: EventEmitter<number> = new EventEmitter<number>();


  private gradeStatusSubscription: Subscription;
  private partialCreditSubscription: Subscription;
  gradeFormGroup = new FormGroup({
    grade: new FormControl(''),
    partialCredit: new FormControl(null)
  });
  partialCredits: number[] = [];

  constructor() { }

  ngOnInit(): void {
    this.setGrade();
    this.checkFormType();
    this.populatePartialDropdown();
    this.gradeStatusSubscription = this.gradeFormGroup.get('grade').valueChanges.subscribe(value => {
      this.gradeStatusChanges.emit(this.gradeFormGroup.getRawValue());
    })
    this.partialCreditSubscription = this.gradeFormGroup.get('partialCredit').valueChanges.subscribe(value => {
      this.partialCreditChanges.emit(this.gradeFormGroup.getRawValue());
    })
  }

  setGrade = () => {
    let grade: string = '';
    if(this.question.RTIModuleType && this.question.RTIModuleType == ViewWorkRTIType["Guided Practice"]){
      grade = this.pointsEarned == null ? 'incorrect' : this.correct ? 'correct' : 'incorrect';
    }
    else if(this.question.TemplateComponentType && this.question.TemplateComponentType == ViewWorkTemplateType["Guided Practice"]){
      grade = this.pointsEarned == null ? 'incorrect' : this.correct ? 'correct' : 'incorrect';
    }
    else if(this.question.TemplateComponentType && this.question.TemplateComponentType == ViewWorkTemplateType["Prior Knowledge"] ){
      grade = this.pointsEarned == null ? 'incorrect' : this.correct ? 'correct' : 'incorrect';
    }
    else if(this.pointsEarned === null && this.questionType === QuestionTypeEnum["MultipleChoice"]){
      grade = 'incorrect';
    }
    else if(this.pointsEarned === null) {
      grade = this.isConsumerCurriculum ? 'incorrect' : 'notGraded';
    } else if (this.pointsEarned === 0 && this.pointsAvailable > 0) {
      grade = 'incorrect';
    } else if (this.pointsEarned > 0) {
      if(this.pointsEarned === this.pointsAvailable) {
        grade = 'correct';
      } else if(this.pointsEarned < this.pointsAvailable) {
        grade = 'partialCredit';
      }
    }
    else{
      grade = this.correct ? 'correct' : 'incorrect';
    }
    this.gradeFormGroup.controls['grade'].setValue(grade);
  }

  checkFormType = () => {
    this.addValidation();
  }

  addValidation = () => {
    this.gradeFormGroup.controls["partialCredit"].setValidators([Validators.max(this.pointsAvailable), Validators.min(0), Validators.pattern('^(0|[1-9][0-9]*)$')]);
    this.gradeFormGroup.controls["partialCredit"].updateValueAndValidity();
  }

  populatePartialDropdown = () => {
    let i = 1;
    while (i < this.pointsAvailable) {
      this.partialCredits.push(i);
      i++;
    }
    this.gradeFormGroup.controls['partialCredit'].setValue(this.partialCredits[0]);
  }

  ngOnDestroy() {
    this.gradeStatusSubscription.unsubscribe();
    this.partialCreditSubscription.unsubscribe();
  }
}
